import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import MaintenancePage from './components/MaintenancePage';
import { getApiUrl } from './config/api';

function MaintenanceGate() {
  const [maintenance, setMaintenance] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(getApiUrl('/api/maintenance-status'))
      .then(res => res.json())
      .then(data => {
        if (!cancelled) setMaintenance(!!data.maintenance);
      })
      .catch(() => {
        if (!cancelled) setMaintenance(false);
      });
    return () => { cancelled = true; };
  }, []);

  if (maintenance === null) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#064e3b', color: '#fff' }}>
        Loading…
      </div>
    );
  }
  if (maintenance) {
    return <MaintenancePage />;
  }
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MaintenanceGate />
  </React.StrictMode>
);
